import request, {noop, parseQueryString, throwErr} from '../utils/request'
import Session from '../session'
import WeixinApi from '../weixin/weixin-api'
import {payPlatform} from '../utils/platform'
import {
    ALIPAY_URL,
    IAlipayResponse,
    INativeRepayResponse,
    IWxpayResponse, NATIVE_REPAY,
    PayOptions,
    WXPAY_URL
} from './pay-constrains'
import Variable from '../utils/variable'
import { getQueryParameter } from '../utils'
import { independentPayment } from './independent-payment'
import { api_getDomainInfoNew, IDomainInfo, IGetDomainInfo } from '../api/payment'
// import {createConfig} from '@weike/envconf-panel'
const GlobalVariable = new Variable().GlobalVariable

const payConf = {
    API_BASE_URL: GlobalVariable.API_BASE_URL
}

// const Config = createConfig('WxpayConfig', payConf)
const Config = payConf

type OnFailed = (err: any) => any
type OnSuccess<T> = (data: T) => any

// app 支付参数
interface IAppPayParams {
    type: 'app'
    data: {
        code: number,
        params: {
          payment_id: number,
          package: string,
          timestamp: string,
          scene: string,
          sign: string,
          partnerid: string,
          appid: string,
          prepayid: string,
          noncestr: string
        },
        msg: string,
        invoice_id: number,
        req_platform: string,
        data: {
          invoice_id: number,
          params: {
            payment_id: number,
            package: string,
            timestamp: string,
            scene: string,
            sign: string,
            partnerid: string,
            appid: string,
            prepayid: string,
            noncestr: string
          }
        },
        trade_platform: 'WECHAT'
      }
}

type PayResult = (
    ({
        type: 'alipay'
        payUrl: string
    } | {
        type: 'wxpay'
        invoiceId: number
    } | {
        type: 'qrcode'
        codeUrl: string
    }) & { data: any }
) | IAppPayParams

class PayManager {

    private readonly session: Session
    private readonly weixinApi?: WeixinApi

    constructor(session: Session, weixinApi?: WeixinApi) {
        this.session = session
        this.weixinApi = weixinApi
    }

    public pay(options: PayOptions,
               onSuccess: OnSuccess<PayResult> = noop,
               onFailed: OnFailed = throwErr,
               onCancel: () => any = noop,
               extraOption: {
                   platform?: 'alipy' | 'weixin' | 'pc' | 'app',
                   onOrder?: (result: PayResult) => void
                } = {}
            ) {
        let query = parseQueryString(location.search)
        const weixinApi = this.weixinApi
        const handlePlatform = extraOption.platform || payPlatform
        // 这里浅拷贝一份出来，防止下面修改到原始对象
        const _options: PayOptions = { origin_domain: window.location.origin, ...options }
        // 当购买的是专栏时，没有传入参数是否独立支付，根据支付信息进行推测，设置默认值。
        if (!_options.getDomainInfo && _options.channel_id && _options.product === 'pay_channel' ) {
          /**
           * 目前虚拟商品 只有专栏类型（pay_channel） 在支持根据专栏去查品类，查商户号进行支付分流。
           * 其他类型的虚拟商品：只支持按域名(origin_domain)和直播间id（liveroom_id）进行支付判断
           * 实体商品见wk-mall
           */
          _options.getDomainInfo = {
            liveroom_id: _options.liveroom_id as number,
            object_type: 'pay_channel',
            object_id: _options.channel_id as number,
            origin: window.location.origin
          }
        }

        // 梨花班班个销：如果search带有from_type & from_id 且为专栏详情页支付
        const from_type = getQueryParameter('from_type')
        const from_id = getQueryParameter('from_id')
        // 获取推广渠道码 https://www.tapd.cn/33512420/prong/stories/view/1133512420001043804
        const order_src_code = getQueryParameter('ord_sc') || undefined
        if (
          from_type
          && from_id
          && _options.product === 'pay_channel'
        ) {
          delete query['from_type']
          delete query['from_id']
          /**
           * from_type: 来源类型
           * from_id: 来源对象id
           * scene: 具体场景，info_page表示详情页
           * order_src_code: 推广渠道码
           */
          query = {
            ...query,
            business_from: JSON.stringify({
              from_type,
              from_id,
              scene: 'info_page',
              order_src_code
            })
          }
        } else {
            try {
                const businessQuery = (_options.business_from || '') as string
                // 只有含有推广渠道字段才执行此操作
                if (order_src_code) {
                    // 移除参数
                    delete query['ord_sc']
                    // 如果有传入business_from，给它塞一个字段
                    if (businessQuery) {
                        const businessObject = JSON.parse(businessQuery)
                        if (businessObject) {
                            businessObject['order_src_code'] = order_src_code
                        }
                        const newBusinessQuery = JSON.stringify(businessObject)
                        // 更新到原始参数上去
                        _options.business_from = newBusinessQuery
                        query = {
                            ...query,
                            business_from: newBusinessQuery
                        }
                    } else {
                        // 没有business_from的情况下，构造一个含order_src_code字段的json
                        query = {
                            ...query,
                            business_from: JSON.stringify({order_src_code})
                        }
                    }
                }
            } catch (err) {}
        }

        if (handlePlatform === 'app') {
            // APP 支付
            // 外部调用微信二维码
            this.getWxpay(_options, {...query, trade_type: 'APP' }, (appData) => {

                if (_options.fee === 0) {
                    onSuccess({
                        type: 'app',
                        data: appData as any
                    })
                } else {
                    if (query.platform && query.user_sign) {
                        this.bindOuterAccount(appData.invoice_id, query.platform, query.user_sign)
                    }

                    // 获取订单信息时，调用extraOption.onOrder
                    extraOption.onOrder && extraOption.onOrder({type: 'app', data: appData as any})

                    onSuccess({
                        type: 'app',
                        data: appData as any
                    })
                }
            }, onFailed)
            return
        }
        if (handlePlatform === 'alipy') {
            // 支付宝付款
            this.getAlipay(_options, query, (data) => onSuccess({
                type: 'alipay',
                payUrl: data.data.params.pay_url,
                data
            }), onFailed)

        } else if (handlePlatform === 'weixin' && weixinApi && (weixinApi.status.wxReady || weixinApi.status.wxBridgeReady)) {
            // 微信内支付
            this.getWxpay(_options, query, (data) => {

                // 获取订单信息时，调用extraOption.onOrder
                extraOption.onOrder && extraOption.onOrder({type: 'wxpay', invoiceId: data.invoice_id, data})

                const success = () => {
                    if (_options.product === 'pay_channel' && query.platform && query.user_sign) {
                        this.bindOuterAccount(data.invoice_id, query.platform, query.user_sign)
                    }
                    onSuccess({type: 'wxpay', invoiceId: data.invoice_id, data})
                }

                if (_options.fee === 0) {
                    success()
                } else {
                    weixinApi.wx.chooseWXPay({
                        ...data.params,
                        success,
                        fail: onFailed,
                        cancel: onCancel
                    })
                }
            }, onFailed)

        } else {
            // 外部调用微信二维码
            this.getWxpay(_options, {...query, trade_type: 'NATIVE' }, (wxData) => {

                if (_options.fee === 0) {
                    onSuccess({
                        type: 'qrcode',
                        codeUrl: '',
                        data: wxData
                    })
                } else {
                    // 不再调用/api/pay/native_repay接口；TAPD：https://www.tapd.cn/20219201/prong/stories/view/1120219201001041262
                    if (query.platform && query.user_sign) {
                        this.bindOuterAccount(wxData.invoice_id, query.platform, query.user_sign)
                    }

                    // 获取订单信息时，调用extraOption.onOrder
                    extraOption.onOrder && extraOption.onOrder({type: 'wxpay', invoiceId: wxData.invoice_id, data: wxData})

                    onSuccess({
                        type: 'qrcode',
                        codeUrl: wxData.params.code_url || '',
                        data: wxData
                    })
                }
            }, onFailed)
        }
    }

    /**
     * 独立支付
     * @param liveroom_id 直播间id
     * @param params 参数 trade_type:交易类型，token:用户token，data:支付所需数据(注意这里是平铺，不需要嵌套多级)
     * @param onSuccess 成功回调
     * @param onFailed 失败回调
     * @returns 是否走独立支付，true:走独立支付（自动跳转独立支付页面），false:不走独立支付（走原始逻辑）
     */
    public async independentPayment(
      liveroom_id: number,
      /**
       * { trade_type: string; data: any } 是支付需要的参数， IGetDomainInfo 是判断是否独立支付需要的参数
       * /// 这里为什么拆分，因为这里已经是对外暴露的公共 API 了，需要兼容老的入参。
       */
      params: { trade_type: string; data: any } & Omit<
        IGetDomainInfo,
        'liveroom_id'
      >,
      onSuccess: OnSuccess<Partial<IDomainInfo>>,
      onFailed: OnFailed,
    ) {
      const { trade_type, data, ...independentOptions } = params
      try {
        const res = await independentPayment(
          {
            liveroom_id,
            ...independentOptions,
          },
          {
            trade_type: trade_type || 'WXPAY',
            data: {
              params: data,
              invoice_id: data.invoice_id,
              appId: data.appId,
            },
          },
        )
        onSuccess && onSuccess(res)
        return res
      } catch (error) {
        onFailed && onFailed(error)
        throw error
      }
    }

    /**
     * 判断是否需要走独立支付
     * @param liveroom_id 直播间id
     * @param getDomainInfo
     *
     * /// 这里为什么拆分 (liveroom_id, getDomainInfo)，因为这里已经是对外暴露的公共 API 了，需要兼容老的入参。
     */
    public hasIndependent(
      liveroom_id: number,
      getDomainInfo: Omit<IGetDomainInfo, 'liveroom_id'>,
    ) {
      return api_getDomainInfoNew({
        liveroom_id,
        ...getDomainInfo,
      })
    }

    private getWxpay(rawOptions: PayOptions,
                     query: { [key: string]: string },
                     onSuccess: OnSuccess<IWxpayResponse>,
                     onFailed: OnFailed) {
        const { getDomainInfo, ...options } = rawOptions
        this.session.getToken(({token}) => {
            return request({
                method: 'GET',
                baseUrl: Config.API_BASE_URL,
                url: WXPAY_URL,
                query: {...query, ...options, token}
            }, async (data) => {
                // 有直播间id的时候，进入独立支付判断，APP一般都是微外，同时APP基本上都是走原生支付。
                if(data.code === 0 && options.liveroom_id && query.trade_type !== 'APP' && options.fee != 0) {
                    try {
                        const res = await independentPayment( {
                          liveroom_id: options.liveroom_id as number,
                          // 发起支付页面来源
                          origin: window.location.origin,
                          ...(getDomainInfo || {}),
                        }, {trade_type: query.trade_type || "WXPAY", data })
                        // 判断是否走独立支付，是：直接跳转独立支付页面，否：继续往下走。
                        if(res.isIndependent) return
                    } catch (error) {
                        // 判断独立支付接口，不能影响正常支付。
                        // onFailed(error)
                       // 判断是否为独立支付异常了 （走到这里，一般是接口异常了，或者返回数据结构异常了 ）
                       console.warn('independentPayment error', error)
                    }
                }
                if(data.code === 0){
                    onSuccess(data)
                }else{
                    onFailed(data)
                }
            }, onFailed)
        }, onFailed)
    }

    private getAlipay(rawOptions: PayOptions,
                      query: { [key: string]: string },
                      onSuccess: OnSuccess<IAlipayResponse>,
                      onFailed: OnFailed) {
        const { getDomainInfo, ...options } = rawOptions
        this.session.getToken(({token}) => {
            return request({
                method: 'GET',
                baseUrl: Config.API_BASE_URL,
                url: ALIPAY_URL,
                query: {...query, ...options, token}
            }, (data) => data.code === 0 ? onSuccess(data) : onFailed(data), onFailed)
        }, onFailed)
    }

    private getNativeRepay(invoiceId: number,
                           onSuccess: OnSuccess<INativeRepayResponse>,
                           onFailed: OnFailed) {
        this.session.getToken(({token}) => {
            return request({
                method: 'POST',
                baseUrl: Config.API_BASE_URL,
                url: NATIVE_REPAY,
                query: {token},
                dataType: 'form',
                data: {invoice_id: invoiceId}
            }, (data) => data.code === 0 ? onSuccess(data) : onFailed(data), onFailed)
        }, onFailed)
    }

    private bindOuterAccount(invoiceId: number, platform: string, userSign: string) {
        this.session.getToken(({token}) => {
            request({
                baseUrl: Config.API_BASE_URL,
                url: `/api/invoice/${invoiceId}/bind_outer_account`,
                query: {token},
                method: 'POST', dataType: 'form',
                data: {platform, user_sign: userSign}
            })
        })
    }

}

export default PayManager
